export default "__VITE_ASSET__Cnl6hmVV__";